import React from 'react';

export default function Arrow() {
	return (
		<div className="arrow">
			<svg className="arrow-svg" version="1.1" x="0px" y="0px" viewBox="0 0 40 40">
				<polygon points="32.0214844,19.1591797 23,28.1799316 23,0 17,0 17,28.1796875 7.9794922,19.1591797
				3.7363281,23.4013672 20,39.6660156 36.2636719,23.4013672 "/>
			</svg>
		</div>
	);
}



// WEBPACK FOOTER //
// ./src/components/Site/Arrow.js